if (!customElements.get('mys-halloween-hero')) {
  customElements.define('mys-halloween-hero', class extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-hero-target]'));
        this.navigation = this.querySelector('[data-hero-navigation]');
        this.slideContainer = this.querySelector('[data-hero-slides]');
        this.pauseButton = this.querySelector('[data-hero-pause]');
        this.current = 0;
        this.rotationRequested = this.dataset.autoRotate === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.buttons.forEach(button => button.addEventListener('click', () => this.select(Number(button.dataset.heroTarget))));
        this.querySelector('[data-hero-previous]')?.addEventListener('click', () => this.select(this.current - 1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.select(this.current + 1));
        this.pauseButton?.addEventListener('click', () => {
          this.rotationRequested = !this.rotationRequested;
          this.syncRotation();
        });
        this.addEventListener('focusin', () => {
          this.rotationRequested = false;
          this.syncRotation();
        });
        this.addEventListener('mouseenter', () => {
          this.pointerInside = true;
          this.syncRotation();
        });
        this.addEventListener('mouseleave', () => {
          this.pointerInside = false;
          this.syncRotation();
        });
        this.handleVisibility = () => {
          this.expire();
          this.syncRotation();
        };
      }
      document.addEventListener('visibilitychange', this.handleVisibility);
      if (this.navigation) this.navigation.hidden = this.slides.length < 2;
      this.expire();
      this.syncRotation();
    }
    select(index) {
      this.rotationRequested = false;
      this.show(index);
      this.syncRotation();
    }
    show(index) {
      if (this.expired || this.slides.length < 2) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => { slide.hidden = position !== this.current; });
      this.buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === this.current)));
    }
    syncRotation() {
      clearInterval(this.rotationTimer);
      const canRotate = this.rotationRequested && !this.expired && this.slides.length > 1;
      if (this.pauseButton) {
        this.pauseButton.setAttribute('aria-label', canRotate ? this.pauseButton.dataset.labelPause : this.pauseButton.dataset.labelPlay);
        this.pauseButton.querySelector('[data-hero-pause-icon]').textContent = canRotate ? 'Ⅱ' : '▶';
      }
      if (this.slideContainer) this.slideContainer.setAttribute('aria-live', canRotate ? 'off' : 'polite');
      if (canRotate && !this.pointerInside && !document.hidden) {
        const interval = Math.max(5000, Number(this.dataset.interval) || 7000);
        this.rotationTimer = setInterval(() => this.show(this.current + 1), interval);
      }
    }
    expire() {
      clearTimeout(this.expiryTimer);
      if (this.dataset.designMode === 'true' || !this.querySelector('[data-campaign-slide]')) return;
      const now = Date.now();
      const start = Date.parse(this.dataset.start);
      const remaining = Date.parse(this.dataset.end) - now;
      if (this.dataset.campaignReady !== 'true' || !Number.isFinite(start) || now < start || !Number.isFinite(remaining) || remaining <= 0) {
        this.expired = true;
        this.current = this.slides.length - 1;
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.current; });
        if (this.navigation) this.navigation.hidden = true;
        this.rotationRequested = false;
        this.syncRotation();
      } else if (Number.isFinite(remaining)) {
        this.expiryTimer = setTimeout(() => this.expire(), Math.min(remaining + 100, 2147483647));
      }
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      clearInterval(this.rotationTimer);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }
  });
}
